import styled from 'styled-components';
import { LanguageSwitcherStyled } from '../LanguageSwitcherStyled';

export const LanguageSwitcherStyledAP = styled(LanguageSwitcherStyled)`
    background-color: ${({ theme }) => theme.colors.grey7};
`;
